import React from 'react';

import RemoteAutocomplete from './RemoteAutocomplete';

const buildJobNameUrl = (search) => {
  const params = new URLSearchParams({ limit: '20', sort: '-id' });
  if (search) {
    params.set('q', search);
  } else {
    params.set('status', 'active');
  }
  return `/jobs?${params.toString()}`;
};

const JobNameAutocomplete = ({ name, value, onChange, sx }) => (
  <RemoteAutocomplete
    autoHighlight={false}
    buildUrl={buildJobNameUrl}
    getOptionKey={(option) => option.id}
    getOptionLabel={(option) => option.name || ''}
    getOptionValue={(option) => option.name || ''}
    lockSelectedOption={false}
    name={name}
    onChange={onChange}
    sx={sx}
    value={value}
  />
);

export default JobNameAutocomplete;
